export default {
  emailjsPublicKey: "xvf4iEONVE8AYTiyK",
  emailjsServiceId: "service_tm9e6hc",
  emailjsTemplateAdmin: "template_9z52lb6",
  emailjsTemplateClient: "template_9z52lb6",
};
